import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router";
import { CiMenuKebab } from "react-icons/ci";
import { BsCloudUpload } from "react-icons/bs";
import { MdOutlineAutoDelete } from "react-icons/md";
import { Collapse, ListGroup } from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { editorProjectServices } from "../../APIServices/Editor/editorProjectServices";
import { editorSuperAdminDataServices } from "../../APIServices/Editor/editorSuperAdminDataServices";
import { FaArrowsRotate, FaCircleInfo, FaClone, FaInfo, FaLaptopCode, FaLock, FaLockOpen, FaPlus } from "react-icons/fa6";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaEdit, FaFolder, FaRegFileCode, FaTrashAlt } from "react-icons/fa";
import Swal from "sweetalert2";
import UseToggle from "../../Hooks/UseToggle";
import AddNewFileFolder from "./ProjectManagement/AddNewFileFolder";
import AddNewDataLibrary from "./ProjectManagement/AddNewDataLibrary";
import ProjectProperties from "./ProjectManagement/ProjectProperties";
import FileDataProperties from "./ProjectManagement/FileDataProperties";
import AddNewFileDataLibrary from "./ProjectManagement/AddNewFileDataLibrary";
import UpdateFileDataLibrary from "./ProjectManagement/UpdateFileDataLibrary";
import ProjectFileProperties from "./ProjectManagement/ProjectFileProperties";
import AddNewProjectManagement from "./ProjectManagement/AddNewProjectManagement";
import UpdateProjectManagement from "./ProjectManagement/UpdateProjectManagement";
import DuplicateFileDataLibrary from "./ProjectManagement/DuplicateFileDataLibrary";
import DeletedProjectManagement from "./ProjectManagement/DeletedProjectManagement";
import UpdateLibraryFolderManagement from "./ProjectManagement/UpdateLibraryFolderManagement";
import UpdateProjectFile from "./ProjectManagement/UpdateProjectFile";
import { NoDataFoundTable, PageLoader } from "../../Components/NoDataFoundTable/NoDataFoundTable";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import UploadLocalSystemFiles from "./ProjectManagement/UploadLocalSystemFiles";
import CheckInFile from "./ProjectManagement/CheckInFile";
import CompareFileVersionHistory from "./ProjectManagement/ProjectEditor/CompareFileVersionHistory";

function ProjectManagementSidebar({
  collapseSidebar,
  onMouseDown,
  tableRef,
  handleAddNewTab,
  checkActiveTabData,
}) {
  const { studyId } = useParams()
  const [loader, setLoader] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [libraryList, setLibraryList] = useState([]);
  const [projectData, setProjectData] = useState(null);
  const [projectDeletedList, setProjectDeletedList] = useState([]);
  let objectIds = checkActiveTabData("projectManagement")?.ids || checkActiveTabData("projectLogData")?.ids || checkActiveTabData("projectOutputData")?.ids || checkActiveTabData("datasetManagement")?.ids || checkActiveTabData("libraryManagement")?.ids || checkActiveTabData("fileManagement")?.ids
  const toggles = UseToggle();
  const AppsRef = useRef(null);
  const [openAddOption, setOpenAddOption] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);

  const studyPermissionData = JSON.parse(localStorage.getItem("studyPermissionData"));

  const getLibraryFileData = async () => {
    let data = await editorSuperAdminDataServices.getLibraryFileData("active", "help");
    setLibraryList(data?.data);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenAddOption(false);
      }
      if (!event.target.closest(".node-menu")) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  const getEditorProjectData = async () => {
    setLoader(true)
    const data = await editorProjectServices.getEditorProjectData("active", studyId);
    setProjectList(data?.data || []);
    setLoader(false)
  };

  const getDeletedEditorProjectData = async (type, parentId) => {
    try {
      const data = await editorProjectServices.getDeletedEditorProjectData(type, parentId || "no", studyId);
      setProjectDeletedList(data?.data || []);
    } catch (err) {
      console.error("Error fetching package data:", err);
    }
  };

  const softDeleteRestoreProjectData = async (id, type, fileType, parentId, projectData) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} dataset!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        let data
        if (projectData?.keepFile === "system") {
          userData.fileName = `${projectData?.name}${projectData?.oldExtension}`;;
          userData.folderPath = `${projectData?.localPath}`;
          data =
            await editorProjectServices.deleteLocalFile(
              userData
            );
        } else {
          userData.studyId = studyId;
          userData.id = id;
          userData.type = type;
          userData.path = projectData?.path;
          data =
            await editorProjectServices.softDeleteRestoreProjectData(
              userData
            );
        }
        if (data?.statusCode === 200) {
          getEditorProjectData();
          getDeletedEditorProjectData(fileType, parentId);
          if (type === "restore") {
            getDeletedEditorProjectData(fileType, parentId);
            if (fileType === "project") {
              toggles.setToggle1();
            }
            if (fileType === "library") {
              toggles.setToggle12();
            }
            if (fileType === "file") {
              toggles.setToggle15();
            }
          }
        }
      }
    });
  };

  const addNewProgrammingEnvironment = async (projectId, parentId, path) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Create Programming Environment!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Create it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.projectId = projectId;
        userData.parentId = parentId;
        userData.path = path;
        let data =
          await editorProjectServices.addNewProgrammingEnvironment(
            userData
          );
        if (data?.statusCode === 200) {
          getEditorProjectData();
        }
      }
    });
  };

  const lockUnlockFolders = async (projectId, uniqueId, level, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} ${level === "child" ? "child level" : "this"} folder!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.projectId = projectId;
        userData.uniqueId = uniqueId;
        userData.level = level;
        userData.type = type;
        let data =
          await editorProjectServices.lockUnlockFolders(
            userData
          );
        if (data?.statusCode === 200) {
          getEditorProjectData();
        }
      }
    });
  };

  const checkInCheckoutProjectCode = async (node) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Check out this file!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Checkout it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.projectId = node?.projectId;
        userData.commonId = node?.commonId;
        userData.name = node?.name;
        userData.type = "checkOut";
        let data =
          await editorProjectServices.checkInCheckoutProjectCode(
            userData
          );
        if (data?.statusCode === 200) {
          getEditorProjectData();
          const studyTabs = JSON.parse(localStorage.getItem("studyTabs"));
          if ((studyTabs || [])?.some(item => item.studyTabId === `projectManagement_${node?.uniqueId}`)) {
            handleAddNewTab(`
              ${node?.name}.${node?.extension} [${node?.path?.split("/")?.[0]}]`,
              "fa-solid fa-database",
              `projectManagement_${node?.uniqueId}`,
              { ...node, checkIn: "no", projectName: node?.path?.split("/")?.[0] }
            )
          }
        }
      }
    });
  };

  useEffect(() => {
    getLibraryFileData();
  }, []);

  useEffect(() => {
    getEditorProjectData();
  }, [objectIds?.runProject]);

  const treeData = useMemo(() => {
    const map = {};
    const roots = [];
    projectList.forEach((item) => {
      map[item.uniqueId || item.projectId] = {
        ...item,
        children: [],
        lockStatus: item.lock === "yes" ? "locked" : "unlocked"
      };
    });
    projectList.forEach((item) => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.uniqueId || item.projectId]);
      } else {
        roots.push(map[item.uniqueId || item.projectId]);
      }
    });
    const setPathAndLock = (nodes, parentPath = "", parentLocked = false) => {
      nodes.forEach(node => {
        const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;
        node.path = currentPath;
        const currentLocked = parentLocked || node.lock === "yes";
        node.lockStatus = currentLocked ? "locked" : "unlocked";
        if (node.children.length > 0) {
          setPathAndLock(node.children, currentPath, currentLocked);
        }
      });
    };
    setPathAndLock(roots);
    return roots;
  }, [projectList]);

  return (
    <>
      <ListGroup.Item className="border-0 border-bottom bg-light" style={{ padding: "6px 10px" }} ref={AppsRef}>
        <div className="hstack justify-content-between w-100">
          <span className="fw-bold">
            <AiOutlineFundProjectionScreen className="me-2" style={{ width: 17, height: 17 }} />
            {!collapseSidebar && <span>Project Management</span>}
          </span>
          {!collapseSidebar && (
            <div className="position-relative" style={{ height: 0 }}>
              <div className="CP" title="Open Action" style={{ marginTop: -13 }} onClick={() => setOpenAddOption(!openAddOption)}>
                <button className="btn btn-sm btn-light br-circle p-0" style={{ height: 26, width: 26 }}>
                  <CiMenuKebab />
                </button>
              </div>
              <Collapse in={openAddOption}>
                <div className="position-absolute z-1" style={{ top: 15, right: -16 }}>
                  <ListGroup className="br3 small">
                    {studyPermissionData?.projectManagement &&
                      <ListGroup.Item
                        action
                        className="text-primary py-1 px-3 fontSize12 text-nowrap"
                        onClick={toggles.setToggle2}
                        title="Add New Project"
                      >
                        <FaPlus className="me-1" /> Add New Project
                      </ListGroup.Item>
                    }
                    <ListGroup.Item
                      action
                      className="text-danger py-1 px-3 fontSize12 text-nowrap"
                      title="Deleted Project History"
                      onClick={() => { toggles.setToggle1(); getDeletedEditorProjectData("project", "") }}
                    >
                      <MdOutlineAutoDelete className="me-1" /> Deleted History
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Collapse>
            </div>
          )}
        </div>
      </ListGroup.Item>
      <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 154px)" }}>
        {loader ? (!collapseSidebar &&
          <PageLoader />
        ) : projectList?.length === 0 ? (
          <NoDataFoundTable MSG={!collapseSidebar && "Project not found!"} />
        ) : (
          treeData.map((pkg) => (
            <TreeNode
              key={pkg.uniqueId || pkg.projectId}
              node={pkg}
              collapseSidebar={collapseSidebar}
              toggles={toggles}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
              setProjectData={setProjectData}
              softDeleteRestoreProjectData={softDeleteRestoreProjectData}
              libraryList={libraryList}
              getDeletedEditorProjectData={getDeletedEditorProjectData}
              handleAddNewTab={handleAddNewTab}
              checkActiveTabData={checkActiveTabData}
              checkInCheckoutProjectCode={checkInCheckoutProjectCode}
              addNewProgrammingEnvironment={addNewProgrammingEnvironment}
              objectIds={objectIds}
              lockUnlockFolders={lockUnlockFolders}
              studyPermissionData={studyPermissionData}
            />
          )))}
      </ListGroup>
      {/* Modals */}
      <CheckInFile
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        getEditorProjectData={getEditorProjectData}
        projectData={projectData}
        handleAddNewTab={handleAddNewTab}
        Title="CheckIn"
      />
      <DeletedProjectManagement
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        softDeleteRestoreProjectData={softDeleteRestoreProjectData}
        projectDeletedList={projectDeletedList}
        Title="Deleted Package History"
        fileType="project"
      />
      <DeletedProjectManagement
        Show={!toggles.toggle12}
        Hide={toggles.setToggle12}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        softDeleteRestoreProjectData={softDeleteRestoreProjectData}
        projectDeletedList={projectDeletedList}
        Title="Deleted Data Library History"
        fileType="library"
      />
      <DeletedProjectManagement
        Show={!toggles.toggle15}
        Hide={toggles.setToggle15}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        softDeleteRestoreProjectData={softDeleteRestoreProjectData}
        projectDeletedList={projectDeletedList}
        Title="Deleted File History"
        fileType="file"
      />
      <AddNewProjectManagement
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getEditorProjectData={getEditorProjectData}
        Title="Add New Project"
      />
      <AddNewFileFolder
        Show={!toggles.toggle18}
        Hide={toggles.setToggle18}
        projectData={projectData}
        type="file"
        getEditorProjectData={getEditorProjectData}
        Title="Add New File"
      />
      <AddNewFileFolder
        Show={!toggles.toggle19}
        Hide={toggles.setToggle19}
        projectData={projectData}
        type="folder"
        getEditorProjectData={getEditorProjectData}
        Title="Add New Folder"
      />
      <UpdateProjectManagement
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getEditorProjectData={getEditorProjectData}
        projectData={projectData}
        Title="Update Project"
      />
      <UpdateProjectFile
        Show={!toggles.toggle20}
        Hide={toggles.setToggle20}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getEditorProjectData={getEditorProjectData}
        projectData={projectData}
        Title="Update Project File"
      />
      <UpdateLibraryFolderManagement
        Show={!toggles.toggle13}
        Hide={toggles.setToggle13}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getEditorProjectData={getEditorProjectData}
        projectData={projectData}
        Title="Update Library"
      />
      <ProjectProperties
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        projectData={projectData}
        Title="Project Properties"
      />
      <CompareFileVersionHistory
        Show={!toggles.toggle6}
        Hide={toggles.setToggle6}
        ids={projectData}
        version={Number(projectData?.version || 0)}
        Title="Compare File Version"
      />
      <ProjectFileProperties
        Show={!toggles.toggle7}
        Hide={toggles.setToggle7}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        projectData={projectData}
        Title="File Properties"
      />
      <FileDataProperties
        Show={!toggles.toggle16}
        Hide={toggles.setToggle16}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        projectData={projectData}
        Title="File Properties"
      />
      <AddNewDataLibrary
        Show={!toggles.toggle8}
        Hide={toggles.setToggle8}
        getEditorProjectData={getEditorProjectData}
        projectData={projectData}
        Title="Add Data Library"
      />
      <AddNewFileDataLibrary Show={!toggles.toggle9} Hide={toggles.setToggle9} projectData={projectData} getEditorProjectData={getEditorProjectData} Title="Upload File Data" />
      <UploadLocalSystemFiles Show={!toggles.toggle21} Hide={toggles.setToggle21} projectData={projectData} getEditorProjectData={getEditorProjectData} Title="Upload File Data" />
      <UpdateFileDataLibrary Show={!toggles.toggle10} Hide={toggles.setToggle10} projectData={projectData} getEditorProjectData={getEditorProjectData} Title="Update File Data" />
      <DuplicateFileDataLibrary Show={!toggles.toggle14} Hide={toggles.setToggle14} projectData={projectData} getEditorProjectData={getEditorProjectData} Title="Duplicate File Data" />
    </>
  );
}

function TreeNode({ node, collapseSidebar, depth = 0, toggles, activeMenu, setActiveMenu, setProjectData, softDeleteRestoreProjectData, libraryList, getDeletedEditorProjectData, handleAddNewTab, checkActiveTabData, checkInCheckoutProjectCode, addNewProgrammingEnvironment, objectIds, lockUnlockFolders, studyPermissionData }) {
  const [open, setOpen] = useState(false);

  const isFolder = node.type !== "file" && node.children?.length > 0;

  const isMenuOpen = activeMenu === (node?.uniqueId || node?.projectId);

  return (
    <>
      <ListGroup.Item
        action
        className={`border-0 rounded-0 ${((objectIds?.fullPath === `${node.path}/`) || (objectIds?.uniqueId || objectIds?.libraryId) === (node.uniqueId || node.libraryId)) && "selectedMenu"} border-bottom ${open ? "bg-light" : ""}`}
        style={{ paddingLeft: !collapseSidebar && depth + 16, paddingTop: 5, paddingBottom: 5 }}
        onClick={() => {
          let projectName = node?.path?.split("/")?.[0]
          if (isFolder || node.type === "help") setOpen(!open);
          if (node.type === "file" && node.extension === "glxdat") {
            let folderName = node?.path?.split("/")?.[2]
            if (node?.libraryId) {
              handleAddNewTab(`
                Help: ${node?.name}.${node?.extension} [Global Project]`,
                "fa-solid fa-database",
                `libraryManagement_${node?.libraryId}`,
                {
                  libraryId: node?.libraryId,
                  name: node?.name,
                  lockStatus: node?.lockStatus
                }
              )
            } else {
              if (node?.keepFile === "system") {
                handleAddNewTab(`
                  ${folderName}: ${node?.name}.${node?.extension} [${projectName}]`,
                  "fa-solid fa-database",
                  `readLocalDatasetManagement_${node?.uniqueId}`,
                  node
                )
              } else {
                handleAddNewTab(`
                  ${folderName}: ${node?.name}.${node?.extension} [${projectName}]`,
                  "fa-solid fa-database",
                  `datasetManagement_${node?.uniqueId}`,
                  {
                    uniqueId: node?.uniqueId,
                    name: node?.name,
                    lockStatus: node?.lockStatus
                  }
                )
              }
            }
          }
          if (node.type === "file" && node.extension === "glx") {
            handleAddNewTab(`
              ${node?.name}.${node?.extension} [${projectName}]`,
              "fa-solid fa-database",
              `projectManagement_${node?.uniqueId}`,
              { ...node, projectName }
            )
          }
          if (node.type === "file" && node.extension === "glxlog") {
            handleAddNewTab(`
              ${node?.name}.${node?.extension} [${projectName}]`,
              "fa-solid fa-database",
              `projectLogData_${node?.uniqueId}`,
              { ...node, projectName }
            )
          }
          if (node.type === "file" && node.extension === "glxoutput") {
            handleAddNewTab(`
              ${node?.name}.${node?.extension} [${projectName}]`,
              "fa-solid fa-database",
              `projectOutputData_${node?.uniqueId}`,
              { ...node, projectName }
            )
          }
          if (node.type === "reportEnvironment") {
            handleAddNewTab(`
                File Management`,
              "fa-solid fa-desktop",
              `fileManagement`,
              {
                name: node?.name,
                uniqueKey: "Standard",
                deleteAccess: true,
                fullPath: `${node?.path}/`,
              }
            )
          }
        }}
        title={node.name}
      >
        <div className={`hstack justify-content-between w-100 ${node?.lock === "yes" ? "text-danger" : (node?.published === "published" || node?.checkIn === "yes") ? "text-success" : node?.published === "processing" ? "text-warning-dark" : ""}`}>
          <span>
            <i className={`me-2 ${node.type === "reportEnvironment" ? "fa-solid fa-folder-closed" : node.type === "codeEnvironment" ? "fa-solid fa-laptop-code" : node.type === "logEnvironment" ? "fa-solid fa-laptop-code" : node.type === "outputEnvironment" ? "fa-solid fa-laptop-code" : node.type === "file" ? "fa-solid fa-file" : "fa-solid fa-folder"}`} />
            {!collapseSidebar && `${node?.name}${node.type === "file" ? `.${node.extension}` : ""}`}
          </span>
          <div className="hstack gap-2">
            {(isFolder || node.type === "help") &&
              (open ? <IoIosArrowUp /> : <IoIosArrowDown />)}
            <div
              onClick={(e) => {
                setActiveMenu(isMenuOpen ? null : node?.uniqueId || node?.projectId);
                e.stopPropagation();
              }}
              style={{ color: (node.type === "help" || ((node?.type === "codeEnvironment" || node?.type === "logEnvironment" || node?.type === "outputEnvironment" || node?.type === "reportEnvironment") && node.name !== "Programs")) ? "#d2d2d2" : "#625e5e" }}
            >
              <CiMenuKebab />
            </div>
          </div>
        </div>
        <Collapse in={isMenuOpen}>
          <div className="position-absolute z-1 node-menu" style={{ top: 34, right: 0 }} onClick={(e) => e.stopPropagation()}>
            <NodeActions
              node={node}
              toggles={toggles}
              setProjectData={setProjectData}
              softDeleteRestoreProjectData={softDeleteRestoreProjectData}
              getDeletedEditorProjectData={getDeletedEditorProjectData}
              checkInCheckoutProjectCode={checkInCheckoutProjectCode}
              addNewProgrammingEnvironment={addNewProgrammingEnvironment}
              lockUnlockFolders={lockUnlockFolders}
              studyPermissionData={studyPermissionData}
            />
          </div>
        </Collapse>
      </ListGroup.Item>
      {(isFolder || node.type === "help") && (
        <Collapse in={open}>
          <ListGroup>
            {node.type === "help"
              ?
              <>
                {libraryList?.map((file) => (
                  <TreeNode
                    key={file.id}
                    node={file}
                    collapseSidebar={collapseSidebar}
                    depth={depth + 16}
                    toggles={toggles}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                    parentName={node.name}
                    libraryList={libraryList}
                    setProjectData={setProjectData}
                    handleAddNewTab={handleAddNewTab}
                    checkActiveTabData={checkActiveTabData}
                    objectIds={objectIds}
                  />
                ))}
                {node.children.map((child) => (
                  <TreeNode
                    key={child.uniqueId || child.projectId}
                    node={child}
                    collapseSidebar={collapseSidebar}
                    depth={depth + 16}
                    toggles={toggles}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                    setProjectData={setProjectData}
                    softDeleteRestoreProjectData={softDeleteRestoreProjectData}
                    libraryList={libraryList}
                    handleAddNewTab={handleAddNewTab}
                    checkActiveTabData={checkActiveTabData}
                    objectIds={objectIds}
                  />
                ))}
              </>
              : node.children.map((child) => (
                <TreeNode
                  key={child.uniqueId || child.projectId}
                  node={child}
                  collapseSidebar={collapseSidebar}
                  depth={depth + 16}
                  toggles={toggles}
                  activeMenu={activeMenu}
                  setActiveMenu={setActiveMenu}
                  setProjectData={setProjectData}
                  softDeleteRestoreProjectData={softDeleteRestoreProjectData}
                  libraryList={libraryList}
                  getDeletedEditorProjectData={getDeletedEditorProjectData}
                  handleAddNewTab={handleAddNewTab}
                  checkActiveTabData={checkActiveTabData}
                  checkInCheckoutProjectCode={checkInCheckoutProjectCode}
                  addNewProgrammingEnvironment={addNewProgrammingEnvironment}
                  objectIds={objectIds}
                  lockUnlockFolders={lockUnlockFolders}
                  studyPermissionData={studyPermissionData}
                />
              ))}
          </ListGroup>
        </Collapse>
      )}
    </>
  );
}

function NodeActions({ node, toggles, setProjectData, softDeleteRestoreProjectData, getDeletedEditorProjectData, checkInCheckoutProjectCode, addNewProgrammingEnvironment, lockUnlockFolders, studyPermissionData }) {
  return (
    <ListGroup className="br3 small">
      {(node?.type === "project" || node?.type === "folder") && node?.addStructure !== "programmingEnvironment" && node?.lockStatus === "unlocked" && (
        <>
          <ListGroup.Item onClick={(e) => { setProjectData(node); toggles.setToggle19() }} action className="text-primary py-1 px-3 fontSize12 text-nowrap">
            <FaFolder className="me-1" /> Add New Folder
          </ListGroup.Item>
          {node?.addStructure !== "customFolder" &&
            <ListGroup.Item onClick={(e) => { addNewProgrammingEnvironment(node?.projectId, node?.uniqueId, node?.path) }} action className="text-primary py-1 px-3 fontSize12 text-nowrap">
              <FaLaptopCode style={{ marginLeft: -1 }} className="me-1" /> Add Program Environment
            </ListGroup.Item>
          }
        </>
      )}
      {(node?.type === "project" || node?.type === "folder") && (
        <>
          {node?.lock === "yes" ?
            <>
              {studyPermissionData?.projectFolderUnLock &&
                <>
                  <ListGroup.Item onClick={() => lockUnlockFolders(node?.projectId, node?.uniqueId, "main", "unlock")} action className="text-success py-1 px-3 fontSize12 text-nowrap">
                    <FaLockOpen className="me-1" /> Unlock Folder
                  </ListGroup.Item>
                  <ListGroup.Item onClick={() => lockUnlockFolders(node?.projectId, node?.uniqueId, "child", "unlock")} action className="text-success py-1 px-3 fontSize12 text-nowrap">
                    <FaLockOpen className="me-1" /> Unlock with Child Folders
                  </ListGroup.Item>
                </>
              }
            </>
            :
            <>
              {studyPermissionData?.projectFolderLock &&
                <>
                  <ListGroup.Item onClick={() => lockUnlockFolders(node?.projectId, node?.uniqueId, "main", "lock")} action className="text-danger py-1 px-3 fontSize12 text-nowrap">
                    <FaLock className="me-1" /> Lock Folder
                  </ListGroup.Item>
                  <ListGroup.Item onClick={() => lockUnlockFolders(node?.projectId, node?.uniqueId, "child", "lock")} action className="text-danger py-1 px-3 fontSize12 text-nowrap">
                    <FaLock className="me-1" /> Lock with Child Folders
                  </ListGroup.Item>
                </>
              }
            </>
          }
        </>
      )}
      {(node?.type === "project" || node?.type === "folder" || (node?.type === "codeEnvironment" || node?.type === "logEnvironment" || node?.type === "outputEnvironment" || node?.type === "reportEnvironment")) &&
        <>
          {(node?.type !== "codeEnvironment" || node?.type !== "logEnvironment" || node?.type !== "ouputEnvironment" || node?.type !== "reportEnvironment") && node?.lockStatus === "unlocked" &&
            <ListGroup.Item onClick={(e) => { setProjectData(node); node?.type === "project" ? toggles.setToggle3() : toggles.setToggle13() }} action className="text-primary py-1 px-3 fontSize12 text-nowrap">
              <FaEdit className="me-1" /> Edit
            </ListGroup.Item>
          }
          {((node?.type === "codeEnvironment" || node?.type === "logEnvironment" || node?.type === "outputEnvironment" || node?.type === "reportEnvironment") && node?.name === "Programs" && node?.lockStatus === "unlocked") &&
            <ListGroup.Item onClick={(e) => { setProjectData(node); toggles.setToggle18() }} action className="text-primary py-1 px-3 fontSize12 text-nowrap">
              <FaRegFileCode className="me-1" /> Add New File
            </ListGroup.Item>
          }
          {(node?.type !== "codeEnvironment" || node?.type !== "logEnvironment" || node?.type !== "ouputEnvironment" || node?.type !== "reportEnvironment") &&
            <>
              {node?.lockStatus === "unlocked" &&
                <ListGroup.Item onClick={() => softDeleteRestoreProjectData(node?._id, "delete", "project", node?.parentId, node)} action className="text-danger py-1 px-3 fontSize12 text-nowrap">
                  <FaTrashAlt className="me-1" /> Delete
                </ListGroup.Item>
              }
              <ListGroup.Item onClick={(e) => { setProjectData(node); toggles.setToggle4() }} action className="py-1 px-3 fontSize12 text-nowrap">
                <FaInfo className="me-1" /> Properties
              </ListGroup.Item>
            </>
          }
        </>
      }
      {(node?.extension === "glx" || node?.extension === "glxoutput" || node?.extension === "glxlog") && (
        <>
          {node?.extension === "glx" && node?.lockStatus === "unlocked" &&
            <>
              {node?.checkIn === "yes" ?
                <ListGroup.Item
                  onClick={() => checkInCheckoutProjectCode(node)}
                  action
                  className={`text-warning-dark py-1 px-3 fontSize12 text-nowrap`}>
                  <FaArrowAltCircleLeft className="me-1" /> Checkout
                </ListGroup.Item>
                :
                <>
                  <ListGroup.Item
                    action className="text-primary py-1 px-3 fontSize12 text-nowrap" onClick={() => { setProjectData(node); toggles.setToggle20() }}>
                    <FaEdit className="me-1" /> Edit
                  </ListGroup.Item>
                  <ListGroup.Item
                    onClick={(e) => { setProjectData(node); toggles.setToggle() }}
                    action
                    className={`text-success py-1 px-3 fontSize12 text-nowrap`}>
                    <FaArrowAltCircleRight className="me-1" /> CheckIn
                  </ListGroup.Item>
                </>
              }
              <ListGroup.Item action className="py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle6() }}>
                <FaArrowsRotate className="me-1" /> Compare
              </ListGroup.Item>
            </>
          }
          <ListGroup.Item onClick={(e) => { setProjectData(node); toggles.setToggle7() }} action className="text-info py-1 px-3 fontSize12 text-nowrap">
            <FaInfo className="me-1" /> Properties
          </ListGroup.Item>
        </>
      )}
      {node?.type === "dataLibrary" && (
        <>
          {node?.lockStatus === "unlocked" &&
            <ListGroup.Item action className="text-primary py-1 px-3 fontSize12 text-nowrap" onClick={() => { setProjectData(node); toggles.setToggle8() }}>
              <FaPlus className="me-1" /> Add New Data Library
            </ListGroup.Item>
          }
          <ListGroup.Item
            action
            className="text-danger py-1 px-3 fontSize12 text-nowrap"
            title="Deleted Data Library History"
            onClick={() => { toggles.setToggle12(); getDeletedEditorProjectData("library", "") }}
          >
            <MdOutlineAutoDelete className="me-1" /> Deleted History
          </ListGroup.Item>
        </>
      )}

      {["help", "analysis", "standard", "raw", "temp", "library"].includes(node?.type) && (
        <>
          {node?.type === "library" && node?.lockStatus === "unlocked" &&
            <ListGroup.Item action className="text-primary py-1 px-3 fontSize12 text-nowrap" onClick={() => { setProjectData(node); toggles.setToggle13() }}>
              <FaEdit className="me-1" /> Edit
            </ListGroup.Item>
          }
          {node?.type !== "help" && node?.fileType === "server" && node?.lockStatus === "unlocked" &&
            <ListGroup.Item action className="text-info py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle9() }}>
              <BsCloudUpload className="me-1" /> Upload data
            </ListGroup.Item>
          }
          {node?.type !== "help" && node?.fileType === "system" && node?.lockStatus === "unlocked" &&
            <ListGroup.Item action className="text-info py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle21() }}>
              <BsCloudUpload className="me-1" /> Upload data
            </ListGroup.Item>
          }
          {node?.type === "library" && node?.lockStatus === "unlocked" &&
            <ListGroup.Item onClick={() => softDeleteRestoreProjectData(node?._id, "delete", "library", node?.parentId, node)} action className="text-danger py-1 px-3 fontSize12 text-nowrap">
              <FaTrashAlt className="me-1" /> Delete Library
            </ListGroup.Item>
          }
          {node?.type !== "help" && node?.fileType === "server" &&
            <ListGroup.Item
              action
              className="text-danger py-1 px-3 fontSize12 text-nowrap"
              title="Deleted File History"
              onClick={() => { toggles.setToggle12(); getDeletedEditorProjectData("file", node?.uniqueId) }}
            >
              <MdOutlineAutoDelete className="me-1" /> Deleted History
            </ListGroup.Item>
          }
        </>
      )}

      {node?.extension === "glxdat" && (
        <>
          {node?.category !== "help" && node?.lockStatus === "unlocked" &&
            <>
              <ListGroup.Item action className="text-primary py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle10() }}>
                <FaEdit className="me-1" /> Edit File
              </ListGroup.Item>
              <ListGroup.Item action className="py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle14() }}>
                <FaClone className="me-1" /> Duplicate File
              </ListGroup.Item>
              <ListGroup.Item onClick={() => softDeleteRestoreProjectData(node?._id, "delete", "file", node?.parentId, node)} action className="text-danger py-1 px-3 fontSize12 text-nowrap">
                <FaTrashAlt className="me-1" /> Delete File
              </ListGroup.Item>
            </>
          }
          <ListGroup.Item action className="text-info py-1 px-3 fontSize12 text-nowrap" onClick={(e) => { setProjectData(node); toggles.setToggle16() }}>
            <FaCircleInfo className="me-1" /> File Properties
          </ListGroup.Item>
        </>
      )}
    </ListGroup>
  );
}

export default ProjectManagementSidebar;